function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirec637"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirec637"] = parcelRequire;
}
parcelRequire.register("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $18c11f3350a906ea$export$f7ad0328861e2f03, (v) => $18c11f3350a906ea$export$f7ad0328861e2f03 = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = {};
function $18c11f3350a906ea$var$register(pairs) {
    var keys = Object.keys(pairs);
    for(var i = 0; i < keys.length; i++)$18c11f3350a906ea$var$mapping[keys[i]] = pairs[keys[i]];
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping[id];
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return resolved;
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7ff2743745f23748$exports = {};

(parcelRequire("27Lyk")).register(JSON.parse('{"9vqfN":"index.b6f6dae6.js","6pcAv":"resa.dfa38154.jpg","7LJKw":"today.7e3d4bc5.jpg","fyV1N":"corporate.17184519.png","3z0BM":"association.21cf1bcc.png","7iZEy":"church.2c5f3103.png","grb1h":"seogora.3e5d09c6.png","jNoyO":"ortskampen.de84b045.png","lyIap":"deadads.30c3295f.png","9eyBv":"idag.afd5727d.png","5fmCU":"swedish_get_ios.c3cb8517.png","7jrY8":"swedish_get.193e8182.png","kQhyf":"lunch.2fa47428.png","b9mag":"event-header-img.19b95914.png","dLnyU":"family.31a33a74.png","F0acb":"freejobs.39ee16b9.png","9zuhE":"skorpor.2d355209.png","ePYTg":"homestay.1eeac8df.png","ezP8n":"nyheter.f3fe0afa.png","if3SM":"nyheter.ad1d7921.jpg","3kSkf":"erbjudanden.3b5a2491.png","ejIIP":"bilder.1e4f6a4b.png","hJRuQ":"police.d21dcf07.png","4e1oC":"temperatur.1b9026ef.jpg","02k6O":"readernews.9cbd34d2.png","fA9Qj":"login.a4837755.png","c5znB":"resa.1b7117f0.png","9Es35":"residence.57b954d2.png","5vHyy":"flower-header-img.6e5c20ac.png","1PF5B":"flower.eba46dad.png","ca6oG":"vader.56aef05a.jpg","aIRtD":"index.c0fd9b38.css"}'));


//# sourceMappingURL=index.b74d1e74.js.map
